module.exports = __webpack_public_path__ + "img/bg.069e470b.png";